import PropTypes from 'prop-types';
import { RecordingSource } from '~/helpers/enums';
import { heroStreamShape } from '~/helpers/propTypeShapes';
import DownloadButtonPicker from '../DownloadButton/DownloadButtonPicker';

export default function BroadcastStreamActionButton({
  stream,
  index,
  isCurrentUserStreamOwner,
  newBroadcastTitle,
  pagePath,
}) {
  const isFileReadyForDownload = stream.outfile?.endsWith('mp4') ?? false;

  if (isFileReadyForDownload) {
    return (
      <DownloadButtonPicker
        type="broadcaststreams"
        namingConvention={isCurrentUserStreamOwner ? RecordingSource.HOST : RecordingSource.GUEST}
        newTitle={newBroadcastTitle}
        downloadFile={stream}
        buttonId={`btn-${index}`}
        pagePath={pagePath}
      />
    );
  }

  return (
    <li
      className="broadcast-option download"
      data-for="herostream-tooltip"
      data-tip="This video recording cannot be downloaded"
    >
      <button type="button" disabled aria-label="Download" />
    </li>
  );
}

BroadcastStreamActionButton.propTypes = {
  index: PropTypes.number.isRequired,
  isCurrentUserStreamOwner: PropTypes.bool.isRequired,
  newBroadcastTitle: PropTypes.string.isRequired,
  pagePath: PropTypes.string.isRequired,
  stream: heroStreamShape.isRequired,
};
